import React from "react";
import Header from "../../components/header1/Header1";
import { useNavigate } from "react-router-dom";
import { useState, useRef } from "react";
import { GoTriangleRight, GoTriangleLeft } from "react-icons/go";
import bannerImage from '../../elements/Group 285.png';
import img1 from "../../elements/AI-Amp'd-Website-Photos-Resize01.jpg";
import img2 from "../../elements/AI-Amp'd-Website-Photos-Resize02.jpg";
import img3 from "../../elements/AI-Amp'd-Website-Photos-Resize03.jpg";
import img4 from "../../elements/AI-Amp'd-Website-Photos-Resize04.jpg";
import img5 from "../../elements/AI-Amp'd-Website-Photos-Resize05.jpg";
import img6 from "../../elements/AI-Amp'd-Website-Photos-Resize06.jpg";
import landing2 from '../../elements/MOU-webpage.png';
import studentLearning1 from '../../elements/MOU webpage-02.png';
import studentLearning2 from '../../elements/MOU webpage-03.png';
import studentLearning3 from '../../elements/MOU webpage-04.png';
import carouselImage from '../../elements/MOU webpage-06.png';
import cardImage from "../../elements/shree's profile photo.png";
import { MdOutlineStarPurple500 } from "react-icons/md";
import { MdFormatQuote } from "react-icons/md";

import Footer from "../../components/footer/Footer";
import PartnerInstitutions from "../../components/partner/Partner";


const CollegeCollab = () => {

    const cardData = [
        {
            name: "Shree Krishna Somani",
            designation: "designation",
            company: "company-name",
            image: cardImage,
            title: "Success Story 1",
            story:
                "I wanted to create something that could break barriers for students in underprivileged areas. This portal bridges the gap by making AI accessible to all, and it’s rewarding to see young minds shaping their future through our platform.",
        },
        {
            name: "Sanjay Jambhale",
            designation: "designation",
            company: "company-name",
            image: cardImage,
            title: "Success Story 2",
            story:
                "Building this portal was a way to share my passion for AI with the next generation. The joy of seeing students gain confidence in cutting-edge technology and apply it creatively and effectively has been truly incredible.",
        },
        {
            name: "Sanjay Kumar",
            designation: "designation",
            company: "company-name",
            image: cardImage,
            title: "Success Story 3",
            story:
                "I remember struggling to find the right resources when I started learning AI. That’s why we designed this portal—to provide curated, structured, and engaging content that simplifies complex concepts for everyone.",
        },
        {
            name: "Anushree Rai",
            designation: "designation",
            company: "company-name",
            image: cardImage,
            title: "Success Story 4",
            story:
                "Our portal isn’t just about teaching AI; it’s about empowering students to think critically and solve real-world problems effectively. Watching them grow from beginners to innovative thinkers has been the most fulfilling part of this incredible journey.",
        },
    ];

    const [activeIndex, setActiveIndex] = useState(0);
    const carouselRef = useRef();

    // const cards = [...Array(6)];

    const handleDotClick = (index) => {
        setActiveIndex(index);
        const cardWidth = carouselRef.current.querySelector(".card").offsetWidth;
        carouselRef.current.scrollTo({
            left: cardWidth * index,
            behavior: "smooth",
        });
    };

    const handlePrev = () => {
        if (carouselRef.current) {
          const scrollAmount = carouselRef.current.offsetWidth / 2;
          if (carouselRef.current.scrollLeft === 0) {
            carouselRef.current.scrollTo({
              left: carouselRef.current.scrollWidth,
              behavior: "smooth",
            });
          } else {
            carouselRef.current.scrollBy({
              left: -scrollAmount,
              behavior: "smooth",
            });
          }
        }
      };
    
      const handleNext = () => {
        if (carouselRef.current) {
          const scrollAmount = carouselRef.current.offsetWidth / 2;
          if (
            carouselRef.current.scrollLeft + carouselRef.current.offsetWidth >=
            carouselRef.current.scrollWidth
          ) {
            carouselRef.current.scrollTo({
              left: 0,
              behavior: "smooth",
            });
          } else {
            carouselRef.current.scrollBy({
              left: scrollAmount,
              behavior: "smooth",
            });
          }
        }
      };




    return (
        <div className="md:mx-20 ">

            <Header />

            <div className="relative w-full">
                            <img
                                src={bannerImage}
                                alt="Banner"
                                className="w-full sm:h-[300px] h-auto object-cover"
                            />
                            <div className="absolute inset-0 flex items-center justify-start top-0 left-0 text-white font-medium p-4 sm:p-6">
                                <div className="flex flex-col w-full sm:w-2/5 p-3">
                                    <p className="text-xl sm:text-xl md:text-xl leading-snug mb-1 text-left break-words lg:text-3xl xl:text-4xl">
                                    Partnering with Institutions to Lead the AI Revolution
                                    </p>
                                </div>
                            </div>
                        </div>

            <div className="mainPage text-base xl:text-4xl">
                <div className="flex flex-col md:flex-row items-center py-10 gap-6 ">
                    <div className="w-full md:w-1/2">
                        <img src={landing2} alt="Learning Program" className="w-full h-auto" />
                    </div>
                    <div className="w-full md:w-1/2 leading-relaxed text-gray-700 space-y-2 px-4 md:px-0">
                        <p className="text-left font-medium md:text-2xl sm:text-lg  2xl:text-3xl">
                        At Agivant, we are shaping the future of AI and technology by partnering with educational institutions to equip students with the skills and hands-on experience to thrive in an AI-driven world.
                        </p>
                        <p className="text-left font-medium md:text-2xl sm:text-lg  2xl:text-3xl">
                        Our collaborations bridge academic learning with real-world application, empowering students to embrace AI as a career ally
                        </p>
                    </div>
                </div>

                <div className=" py-3 ">
                    <h2 className="md:text-4xl sm:2xl leading-relaxed font-bold text-center text-gray-900 mb-4 ">
                        Our AI-Amplified Software Engineering Program has been specially designed to:
                    </h2>


                    <div className=" md:px-20 items-center justify-center">

                        <div className="flex flex-col md:flex-row justify-center items-center md:space-x-12  px-4 md:px-20">
                            <div className="relative md:w-1/3 h-auto">
                                <img
                                    src={studentLearning1}
                                    className="rounded-xl w-full h-full object-cover"
                                />
                            </div>
                            <div className="text-center md:text-left md:w-1/2">
                                <h2 className="text-lg md:text-xl lg:text-xl 2xl:text-3xl  font-semibold text-gray-800 leading-relaxed">
                                    Enable students to gain cutting-edge knowledge and skills in AI and software engineering.
                                </h2>
                            </div>
                        </div>


                        <div className="flex flex-col md:flex-row-reverse justify-center items-center md:space-x-12 px-4 md:px-20">
                            <div className="relative md:w-1/3 h-auto">
                                <img
                                    src={studentLearning2}
                                    className="rounded-xl w-full h-full object-cover"
                                />
                            </div>
                            <div className="text-center md:text-left md:w-1/2">
                                <h2 className="text-lg md:text-xl lg:text-xl  2xl:text-3xl  font-semibold text-gray-800 leading-relaxed">
                                    Get exposure to real-world problem-solving through industry-grade projects and internships.
                                </h2>
                            </div>

                        
                    </div>

                        <div className="flex flex-col md:flex-row justify-center items-center md:space-x-12 px-4 md:px-20">
                            <div className="relative md:w-1/3 h-auto">
                                <img
                                    src={studentLearning3}
                                    className="rounded-xl w-full h-full object-cover"
                                />
                            </div>
                            <div className="text-center md:text-left md:w-1/2">
                                <h2 className="text-lg md:text-xl lg:text-xl 2xl:text-3xl font-semibold text-gray-800 leading-relaxed">
                                    Foster a community of innovation where academic leaders, industry experts, and students work hand-in-hand to solve future challenges.
                                </h2>
                            </div>
                        </div>




                    </div>

                    <div className="bg-gray-200 py-8 my-4 hidden">
                        <h2 className="text-4xl font-bold text-center text-gray-900 mb-6">
                            Testimonials
                        </h2>

                        <div className="relative md:justify-center  overflow-hidden w-full">
                            <div className="flex items-center justify-center space-x-4">
                                <button
                                          onClick={handlePrev}
                                          className="bg-transparent text-black rounded-full p-2 z-10 sm:left-4 md:left-8"
                                        >
                                          <GoTriangleLeft className="text-xl sm:text-2xl md:text-3xl" />
                                        </button>
                                <div
                                    ref={carouselRef}
                                    className="carousel flex space-x-16 pt-8 pb-4 px-8 snap-x snap-mandatory overflow-x-scroll overflow-y-hidden scroll-smooth scrollbar-hide [&::-webkit-scrollbar]:[width:10px] [&::-webkit-scrollbar-thumb]:bg-transparent [&::-webkit-scrollbar-thumb]:[border-radius:10px]"
                                >
                                    {cardData.map((card, index) => (
                                        <div
                                            key={index}
                                            className="card flex-shrink-0 w-72 sm:w-80 bg-white  px-6 rounded-lg relative h-auto shadow-md "
                                        >

                                            <div className="absolute -top-8 -left-6 md:w-26 md:h-26 w-28 h-28 rounded-full overflow-hidden">
                                                <img
                                                    src={card.image}
                                                    alt="Profile"
                                                    className="w-full h-full object-fit rounded-full shadow-md "
                                                />
                                            </div>


                                            <div className="mt-10 flex flex-col items-end text-center">
                                                <p className="text-lg font-bold text-gray-900 mb-1 leading-5">
                                                    {card.name}
                                                </p>
                                                <p className="text-sm font-semibold text-gray-400 mb-2">
                                                    {card.designation}
                                                </p>
                                                <hr className="w-3/4 border-gray-300" />
                                            </div>


                                            <p className="text-sm text-gray-500 text-left mt-4">
                                              {card.story}
                                            </p>


                                            <div className="relative flex justify-center items-center">
                                                <div className="absolute -top-8 -right-6 sm:-top-8 sm:-right-8 lg:-top-16 lg:-right-14">
                                                    <MdFormatQuote className="text-gray-400 opacity-50 w-12 h-12 sm:w-20 sm:h-20 lg:w-28 lg:h-28" />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <button
                                          onClick={handleNext}
                                          className="bg-transparent text-black rounded-full p-2 z-10 sm:right-4 md:right-8"
                                        >
                                          <GoTriangleRight className="text-xl sm:text-2xl md:text-3xl" />
                                        </button>
                            </div>



                            <div className="flex justify-center space-x-2 mt-4">
                                {cardData.map((_, index) => (
                                    <div
                                        key={index}
                                        className={`w-3 h-3 rounded-full cursor-pointer ${activeIndex === index
                                            ? "bg-gray-800"
                                            : "bg-gray-400"
                                            }`}
                                        onClick={() => handleDotClick(index)}
                                    ></div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* <div className=" py-8 my-4">
                        <h2 className="text-4xl font-bold text-center text-gray-900 mb-4  ">
                            Success Stories
                        </h2>

                        <hr className="border-2  mb-4" />
                        <div class="relative max-w-4xl mx-auto px-5 py-10 h-[500px] scrollbar-hide   ">
                            <div class="[&::-webkit-scrollbar]:[width:10px]
            [&::-webkit-scrollbar-thumb]:bg-gray-300 
            [&::-webkit-scrollbar-thumb]:[border-radius:10px] 
            overflow-y-scroll 
            overflow-x-hidden 
            h-96">
                                <div class="grid grid-cols-1 md:grid-cols-2 ">
                                    {cardData.map((card, index) => (
                                        <div
                                            key={index}
                                            class="flex flex-col bg-white p-8 w-80 mx-auto rounded-lg"
                                        >
                                            <div className="flex flex-row items-center sm:items-center justify-center h-full sm:mb-2">
                                                <img
                                                    src={card.image}
                                                    alt="Profile"
                                                    class="w-16 h-16 sm:w-24 sm:h-24 mb-2 sm:mb-2"
                                                />
                                                <div className="flex flex-col  items-start sm:mb-2">
                                                    <p class="md:text-base font-bold text-gray-800 mb-0 text-left">
                                                        {card.name}
                                                    </p>
                                                    <p class="md:text-base font-normal text-gray-400 mb-1 text-left">
                                                        {card.designation}
                                                    </p>
                                                    <hr className="flex justify-start text-gray-400 border-2  "/>
                                                </div>
                                            </div>

                                            <div class="flex-1 bg-gray-100 py-3 px-2 mt-1">
                                                <p class="text-sm text-gray-600 font-normal leading-relaxed text-left">
                                                    {card.story}
                                                </p>
                                                <button class="px-6 py-2 mx-2 bg-black text-sm text-white rounded-full hover:bg-white hover:text-black border-2 border-black font-bold focus:outline-none">
                                                    Read More
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                                </div>


                            </div>
                        </div>
                        <hr className="border-2 shadow  " />
                    </div> */}



                    <div className="bg-gray-200 text-center p-6 mt-2">
                        <h2 className="text-4xl font-bold text-center text-gray-900 mb-4">
                            Event Gallery

                        </h2>
                        <div class="columns-1 md:columns-2 xl:columns-3 gap-7 ">
                            <div class=" break-inside-avoid mb-8">
                                <img class="h-auto max-w-full rounded-lg" src={img1} alt="Gallery image" />
                            </div>
                            <div class=" break-inside-avoid  mb-8">
                                <img class="h-auto max-w-full rounded-lg" src={img2} alt="Gallery image" />
                            </div>
                            <div class=" break-inside-avoid  mb-8">
                                <img class="h-auto max-w-full rounded-lg" src={img3} alt="Gallery image" />
                            </div>
                            <div class=" break-inside-avoid  mb-8">
                                <img class="h-auto max-w-full rounded-lg" src={img4} alt="Gallery image" />
                            </div>
                            <div class=" break-inside-avoid  mb-8">
                                <img class="h-auto max-w-full rounded-lg" src={img5} alt="Gallery image" />
                            </div>
                            <div class=" break-inside-avoid  mb-8">
                                <img class="h-auto max-w-full rounded-lg" src={img6} alt="Gallery image" />
                            </div>

                        </div>

                    </div>

                    {/* <PartnerInstitutions /> */}

                    
                </div>
            </div >
            <Footer />
        </div>
    );
};

export default CollegeCollab;
